"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_drag_drop_module_1 = require("./src/ng2-drag-drop.module");
exports.Ng2DragDropModule = ng2_drag_drop_module_1.Ng2DragDropModule;
var drop_event_model_1 = require("./src/shared/drop-event.model");
exports.DropEvent = drop_event_model_1.DropEvent;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-drag-drop/index.js
// module id = 359
// module chunks = 9